import React, { useEffect } from 'react'

import Alert from '../../../1stlog-ui/src/components/Alert'
import screenshotData from './screenshotdata'

type TBlockedPopupAlertProps = { onClose: () => void }

const BlockedPopupAlert = (props: TBlockedPopupAlertProps): React.ReactElement => {
  const { onClose } = props

  useEffect(() => {})

  return (
    <Alert
      dismissible={!!onClose}
      onClose={onClose}
      danger
      title={i18n.t('popup_blocked_alert_title', 'Labelfenster wurde blockiert!')}
    >
      {i18n.t(
        'popup_blocked_alert_message',
        'Das Fenster mit dem Label wurde von Ihrem Browser blockiert. Bitte folgen Sie den Anweisungen, um das Label anzeigen zu können.'
      )}
      <br />
      <br />
      <img src={screenshotData} />
    </Alert>
  )
}

export default BlockedPopupAlert
